import React from "react";
import { Link } from "react-router-dom";
import { datumKort, cap, effDeadline } from "@/components/afspraken/afsprakenUtils";

const CHIP = "px-2.5 py-1 rounded-full border text-xs font-semibold transition-colors";
const STATUS = { nagekomen: "Nagekomen", niet: "Niet nagekomen" };

export function laatsteMelding(a) {
  const r = Object.values(a.afdelingReported || {}).filter((x) => x && (x.note || x.reported)).sort((x, y) => (y.at || "").localeCompare(x.at || ""))[0];
  if (!r) return null;
  return `${cap(r.by || "Afdeling")} meldt${r.reported ? " · gereed" : ""}${r.note ? `: "${r.note}"` : ""}`;
}

// v19-B2: één lopende afspraak in het overleg, met de laatste melding, de werkbon en de deadline.
export const OverlegAfspraak = ({ a, besproken, bewerkbaar, onActie }) => {
  const dl = effDeadline(a);
  const melding = laatsteMelding(a);
  const open = a.status === "open";
  return (
    <li data-testid={`overleg-afspraak-${a.id}`} className="px-3 py-2.5">
      <div className="flex items-start justify-between gap-3">
        <Link to={`/afspraken?select=${a.id}`} className="text-[13.5px] font-semibold text-zinc-900 hover:text-blue-700">{a.wat}</Link>
        <span className={`shrink-0 font-mono text-[11px] ${a.overdue ? "text-rose-600 font-bold" : "text-zinc-500"}`}>{dl ? datumKort(dl) : "geen deadline"}{a.overdue ? " · te laat" : ""}</span>
      </div>
      <div className="text-xs text-zinc-500 mt-0.5">
        {a.locatie || "Algemeen"} · door {cap(a.door)}{a.werkbon && <> · <span data-testid={`overleg-werkbon-${a.id}`} className="font-mono text-zinc-700">Werkbon {a.werkbon}</span></>}
      </div>
      <div data-testid={`overleg-melding-${a.id}`} className="text-xs text-zinc-600 mt-0.5">{melding || "Geen melding van de afdeling"}</div>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {!open && <span data-testid={`overleg-status-${a.id}`} className={`${CHIP} ${a.status === "nagekomen" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-rose-50 text-rose-700 border-rose-200"}`}>{STATUS[a.status]}{a.vervolgId ? " · vervolg gemaakt" : ""}</span>}
        {open && besproken && <span data-testid={`overleg-loopt-${a.id}`} className={`${CHIP} bg-zinc-100 text-zinc-700 border-zinc-300`}>Loopt · besproken</span>}
        {open && bewerkbaar && (<>
          <button type="button" data-testid={`overleg-nagekomen-${a.id}`} onClick={() => onActie(a, "nagekomen")} className={`${CHIP} bg-white text-zinc-700 border-zinc-300 hover:bg-emerald-50 hover:border-emerald-300`}>Nagekomen</button>
          <button type="button" data-testid={`overleg-niet-${a.id}`} onClick={() => onActie(a, "niet")} className={`${CHIP} bg-white text-zinc-700 border-zinc-300 hover:bg-rose-50 hover:border-rose-300`}>Niet nagekomen → vervolg</button>
          {!besproken && <button type="button" data-testid={`overleg-loopt-knop-${a.id}`} onClick={() => onActie(a, "loopt")} className={`${CHIP} bg-white text-zinc-700 border-zinc-300 hover:bg-zinc-100`}>Loopt</button>}
        </>)}
      </div>
    </li>
  );
};
